import React from 'react';
import { PropTypes } from 'prop-types';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { redirectToLogout } from 'actions';
import Button from 'components/Common/Buttons';

class MenuMobile extends React.Component {
  static propTypes = {
    showLogout: PropTypes.bool,
    usePreQualifyingQuestionnaire: PropTypes.bool
  };

  static defaultProps = {
    showLogout: false,
    usePreQualifyingQuestionnaire: false
  };

  constructor(props) {
    super(props);
    this.state = {
      isMenuOpen: false
    };
  }

  toggle() { const { isMenuOpen } = this.state; this.setState({ isMenuOpen: !isMenuOpen }); }

  render() {
    const { showLogout, usePreQualifyingQuestionnaire } = this.props;
    const { isMenuOpen } = this.state;

    return (
      <nav className="menu-mobile">
        <button type="button" className="menu-icon" aria-label="Menu" tabIndex="0" onClick={ () => this.toggle() }>
          { isMenuOpen && <FontAwesomeIcon icon="times" size="2x" /> }
          { !isMenuOpen && <FontAwesomeIcon icon="bars" size="2x" /> }
        </button>
        <div className={ `mobile-menu-content ${ isMenuOpen ? 'open' : '' }` }>
          <div className="links">
            <Link to={ usePreQualifyingQuestionnaire ? '/' : '/form-selection' } className="btn btn-link" onClick={ () => this.toggle() }>
              <FontAwesomeIcon icon="home" size="lg" />
              { usePreQualifyingQuestionnaire ? 'Home' : 'Form Selection' }
            </Link>
            { showLogout && <Button value="" className="btn-link m-0 text-left" onClick={ () => redirectToLogout() }>
              <FontAwesomeIcon icon="sign-out-alt" size="lg" />
              Logout
            </Button> }
          </div>
        </div>
      </nav>
    );
  }
}

const mapDispatchToProps = dispatch => ({ dispatch });

function mapStateToProps(state) {
  const {
    app: {
      onlineConfig
    },
  } = state;

  return {
    usePreQualifyingQuestionnaire: onlineConfig && onlineConfig.usePreQualifyingQuestionnaire,
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(MenuMobile);
